var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 74.813,
    height: 74.813,
    viewBox: "0 0 74.813 74.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1495",
    "data-name": "Rectangle 1495",
    width: 74.813,
    height: 74.813,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_781",
    "data-name": "Group 781",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_780",
    "data-name": "Group 780",
    transform: "translate(0 0.001)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_690",
    "data-name": "Path 690",
    d: "M37.407,3.664A33.743,33.743,0,1,1,3.664,37.407,33.781,33.781,0,0,1,37.407,3.664m0-3.664A37.407,37.407,0,1,0,74.813,37.407,37.407,37.407,0,0,0,37.407,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_691",
    "data-name": "Path 691",
    d: "M33.652,40.273c3.8,1.53,6.49,3.768,7.982,6.752a21.624,21.624,0,0,1,2.237,9.027l.113,1.9v1.53H38.2V57.395c-.111-5.11-1.193-8.729-3.469-11.079a11.231,11.231,0,0,0-5.968-3.133,26.435,26.435,0,0,0-5.111-.485H19.663V37.848h4.7a21.24,21.24,0,0,0,4.328-.522,11.182,11.182,0,0,0,6.042-3.1c2.276-2.351,3.358-6.043,3.469-11.153V20.5h5.782v2.089a9.366,9.366,0,0,1-.113,1.827,21.924,21.924,0,0,1-2.237,9.027,14.536,14.536,0,0,1-7.982,6.826",
    transform: "translate(-0.733 -0.765)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIcon);
export default __webpack_public_path__ + "static/media/hero-icon.97073bb61aaa94bbb6a3573b3072f37e.svg";
export { ForwardRef as ReactComponent };